// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__q6cJA","rotate":"Loader_rotate__vid6O"};